// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip-container[data-v-5bcd451e]{height:45px;background-color:#fff}.selectClassTruncate[data-v-5bcd451e]{min-width:280px}div .selectClassTruncate[data-v-5bcd451e] .v-select__selection--comma{width:250px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}#addClassMenu[data-v-5bcd451e]{box-shadow:none}.playlistSelect[data-v-5bcd451e]{max-width:280px}", ""]);
// Exports
module.exports = exports;
